<!-- Slider Input for Inspector -->
<script lang="ts">
  import Slider from '@/ui/base/Slider.svelte';

  let {
    value = $bindable(0),
    min = 0,
    max = 1,
    step = 0.01,
    showInput = true,
    onChange,
  }: {
    value: number;
    min?: number;
    max?: number;
    step?: number;
    showInput?: boolean;
    onChange?: (value: number) => void;
  } = $props();

  function handleChange(newValue: number) {
    value = newValue;
    onChange?.(value);
  }
</script>

<Slider {value} {min} {max} {step} onChange={handleChange} {showInput} inputWidth="w-16" />
